<div class="layout-sidebar">
    <app-menu></app-menu>
</div>
